import Swiper from 'swiper';
import { Navigation, Autoplay, EffectFade, A11y } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/effect-fade';
import 'swiper/css/a11y';
import './TestimonialSlider.css';

function testimonialSlider() {
    const sliders = document.querySelectorAll('[data-testimonial-slider]');

    // Loop to all existing elements
    sliders.forEach((slider) => {
        const sliderContainer = slider.querySelector('.swiper');

        if(sliderContainer instanceof HTMLElement) {
            new Swiper(sliderContainer, {
                // Install modules
                modules: [Navigation, Autoplay, EffectFade, A11y],
                autoplay: true,
                touchRatio: 1,
                effect: 'fade',
                fadeEffect: {
                    crossFade: true
                },
                autoHeight: true,
                navigation: {
                    nextEl: '.testimonial-slider__control-next',
                    prevEl: '.testimonial-slider__control-prev',
                },
                // Responsive breakpoints
                breakpoints: {
                    // when window width is <= 1024px
                    1024: {
                        touchRatio: 0,
                    },
                }
            });
        }
    })
}

export default testimonialSlider;